<div fxLayout="row" class="padding-content" fxLayoutAlign="center center">
  <div class="reset-confirmation-page-form">
     <div *ngIf="state === 'change' || state ==='loading'">
          <div class="header">
              <circle-al-logo></circle-al-logo>
              <div class="title"><h2>Password Reset</h2></div>
          </div>
          <div class="form-div">
              <form #changePasswordForm="ngForm"  (ngSubmit)="onSubmit()">
                  <div class="row-div">
                      <div class="cell-div">
                          <div class="inner-form">
                              <div class="login-fields">
                                  <div class="password-policy">Password must have at least 12 characters and contain uppercase and lowercase letters, numbers, and special characters. The password cannot be identical to your current or previous four passwords.</div>
                                  <mat-form-field class="mat-block">
                                      <input matInput [(ngModel)]="oldPassword"
                                          [type]="showOldPassword ? 'text' : 'password'" name="oldPassword"
                                          placeholder="Old Password" required class="input-text-field"/>
                                          <div class="show-toggle" (click)="toggleShowOldPassword()">SHOW</div>
                                          <mat-error>You must enter your old password.</mat-error>
                                  </mat-form-field>
                                  <mat-form-field class="mat-block">
                                      <input matInput [(ngModel)]="newPassword"
                                          [type]="showNewPassword ? 'text' : 'password'"
                                          name="newPassword"
                                          placeholder="New Password" class="input-text-field"
                                          required validateEqual="confirmPassword" reverse="true" #password="ngModel"/>
                                      <div class="show-toggle" (click)="toggleShowNewPassword()">SHOW</div>
                                      <mat-error [hidden]="password.valid || (password.pristine && !changePasswordForm.submitted)">You must enter a new password.</mat-error>
                                  </mat-form-field>
                                  <mat-form-field class="mat-block">
                                      <input matInput [(ngModel)]="confirmPassword"
                                          [type]="showConfirmNewPassword ? 'text' : 'password'"
                                          name="confirmPassword"
                                          placeholder="Confirm New Password" class="input-text-field"
                                          required validateEqual="newPassword" reverse="false" #passwordConfirm="ngModel"/>
                                      <div class="show-toggle" (click)="toggleShowConfirmNewPassword()">SHOW</div>
                                     <mat-error [hidden]="passwordConfirm.valid || (passwordConfirm.pristine && !changePasswordForm.submitted)">Your new password and confirmation password do not match.</mat-error>
                                 </mat-form-field>
                             </div>
                             <div class="page-buttons">
                                 <button type="submit" mat-raised-button color="primary" class="button-width" [disabled]="!changePasswordForm.form.valid || (newPassword != confirmPassword) ">RESET PASSWORD</button>
                             </div>
                          </div>
                     </div>
                 </div>
             </form>
          </div>
     </div>
     <al-loading-spinner *ngIf="state === 'loading'"></al-loading-spinner>
     <div *ngIf="state === 'done'">
         <div class="header">
             <circle-success></circle-success>
             <div class="title"><h2>Success!</h2></div>
         </div>
          <div class="reset-text">
             Your password was reset.
          </div>
         <button mat-raised-button color="primary" class="button-width" (click)="onReturnToLogin()">BACK TO LOGIN SCREEN</button>
      </div>
     <div *ngIf="errorMessage">
         <mat-card>
              <mat-card-title-group>
                  <mat-card-content>{{errorMessage}}</mat-card-content>
                  <i (click)="closeMessageError()" class="material-icons">cancel</i>
             </mat-card-title-group>
         </mat-card>
     </div>
  </div>
</div>
